module.exports = __webpack_public_path__ + "img/opencloud-logo.12c2b9f3.png";